import React from "react"

export default function RequiredStar(props) {
  return (
    <span style={{ color: "red" }} {...props}>
      *
    </span>
  )
}
